/**
=========================================================
* Vue SEVICA - v3.0.0
=========================================================
* Product Page: https://picko.sevica.es
* Copyright 2023 Sevica (https://www.sevica.es)
Coded by mnavarro
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import "./assets/js/nav-pills.js";
import "./assets/scss/soft-ui-dashboard.scss";

export default {
  // eslint-disable-next-line prettier/prettier
  install() { }
};
